import { isAdminMode, getEmployeeFormId } from "EmployeeDashboard/selectors";
import { takeLatest } from "redux-saga";
import { call, put, select } from "redux-saga/effects";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import { formParseDate } from "Common/forms/utils";

import { UPDATE_MEDICAL_PLAN, REQUEST_MEDICAL_PLAN_UPDATE } from "./Actions";
import { getBirthDate, getDependentType } from "./Selectors";

export function* watchRequestMedicalPlanUpdate() {
  yield takeLatest(REQUEST_MEDICAL_PLAN_UPDATE, function* () {
    const adminMode = yield select(isAdminMode);
    const employeeFormId = yield select(getEmployeeFormId);
    const birthDate = yield select(getBirthDate);
    const dependentType = yield select(getDependentType);
    const response = yield call(handleRequestMedicalPlanUpdateApi, adminMode, employeeFormId, dependentType, birthDate);
    yield put({
      type: UPDATE_MEDICAL_PLAN,
      newDependentPlans: response.plans,
      newDependentCost: response.current_cost,
    });
  });
}

const formParseEmployeeDependent = (values: any) => ({
  ...values,
  bornAt: formParseDate(values.bornAt),
});

function handleRequestMedicalPlanUpdateApi(adminMode, employeeFormId, dependentType, bornAt) {
  const apiURL = adminMode
    ? `/company-admin/employee-dashboard/${employeeFormId}/employee-dependent-pricing`
    : "/employee-dashboard/employee-dependent-pricing";
  return fetchWithCSRFToken(apiURL, {
    method: "POST",
    body: JSON.stringify({
      employee_dependent: formParseEmployeeDependent({
        dependentType,
        bornAt,
      }),
    }),
    processData: false,
  }).then((response) => response.json());
}
